module.exports = __webpack_public_path__ + "img/menu_njjd.91565102.png";